import e from "./ghl-ui.es1666.js";
import n from "./ghl-ui.es1667.js";
import a from "./ghl-ui.es1668.js";
function l(o) {
  var s = n();
  return function() {
    var r = e(o), t;
    if (s) {
      var u = e(this).constructor;
      t = Reflect.construct(r, arguments, u);
    } else
      t = r.apply(this, arguments);
    return a(this, t);
  };
}
export {
  l as default
};
